import { Grid } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';

const ImageGrid = styled(Grid)`
  margin: auto 2rem;
`;
const ImageSlider = styled(Img)`
  width: 100%;
  max-width: 400px;
`;
const Slide = ({ index, image, directionSlide }) => {
  return (
    <Grid
      container
      direction={directionSlide}
      wrap="nowrap"
      justify="center"
      key={`Slides${index}`}
      alignItems="center"
    >
      <ImageGrid container item xs={8} sm={6} md={6} lg={6} justify="center">
        <ImageSlider fluid={image.childImageSharp.fluid} />
      </ImageGrid>
    </Grid>
  );
};
export default Slide;
